<div class="SLV2-chapter-box">
    <div class="SLV2-chapter-header">
        <img *ngIf="((!isUserSubcribed) && ((!chapterData?.unlockStatus) && isFromLearn))" src="selflearnv2-ui/assets/img/self-learn-v2/crown-with-bg-icon.svg" class="SLV2-crown-tag" />
        <div class="SLV2-chapter-progress-wrap {{cardSubject?.replace(' ','') | lowercase}}">
            <apx-chart [series]="donutchartOptions1.series" [chart]="donutchartOptions1.chart"
                [labels]="donutchartOptions1.labels" [dataLabels]="donutchartOptions1.dataLabels"
                [legend]="donutchartOptions1.legend" [responsive]="donutchartOptions1.responsive"
                [tooltip]="donutchartOptions1.tooltip" [fill]="donutchartOptions1.fill"
                [stroke]="donutchartOptions1.stroke" [states]="donutchartOptions1.states"
                [plotOptions]="donutchartOptions1.plotOptions" class="apx-donut-chart"></apx-chart>
        </div>
        <div class="SLV2-chapter-info">
            <h4 class="SLV2-chapter-info-heading">{{chapterData?.chapterName}}</h4>
            <h5 class="SLV2-chapter-info-subheading">{{chapterData?.topicsCount}}{{chapterData?.topicsCount==1 ?' topic':' topics'}} </h5>
            <!-- <span (click)="openChapterUnlockDialog()">click</span> -->
        </div>
    </div>

</div>


<!-- {{cardSubject}}{{chapterData | json}}<br> -->